import sliceCreator from '../../index.jsx';
import {UPDATE_DAILY_TASK} from '../../../constants/index.jsx';
const _updateDailyTaskAction = sliceCreator('UPDATE_DAILY_TASK', UPDATE_DAILY_TASK, 'put');

const { asyncAction: updateDailyTaskAction, reducer, clearData: clearUpdateDailyTaskAction } = _updateDailyTaskAction;

export default reducer;

export {
    updateDailyTaskAction,
    clearUpdateDailyTaskAction
}